let searchTimeout = '';
export default {
    init() {
        this.initForm();
        this.initDateTimePickers();
    },
    initForm() {
        let $this = this;
        $('body').on('click', '.btn-left', function (e) {
            e.preventDefault();
            let input = $('#page_top');
            let input_bottom = $('#page_bottom');
            let min = input.attr('min');
            let page = input.val();
            let prev_page = input.val();
            if (page > min) {
                page--;
            }
            input.val(page);
            input_bottom.val(page);
            if (page !== prev_page) {
                $this.updateAllShiftsTable();
                $this.updateMyOrdersTable();
            }
        });
        $('body').on('click', '.btn-right', function (e) {
            e.preventDefault();
            let input = $('#page_top');
            let input_bottom = $('#page_bottom');
            let max = input.attr('max');
            let page = input.val();
            let prev_page = input.val();
            if (page < max) {
                page++;
            }
            input.val(page);
            input_bottom.val(page);
            if (page !== prev_page) {
                $this.updateAllShiftsTable();
                $this.updateMyOrdersTable();
            }
        });
        $('body').on('change', 'input[name="page"]', function (e) {
            e.preventDefault();
            let input = $('#page_top');
            let min = input.attr('min');
            let max = input.attr('max');
            if (input.val() >= min && input.val() <= max) {
                $this.updateAllShiftsTable();
                $this.updateMyOrdersTable();
            }
        });
        $('body').on('change', 'select[name="count"]', function (e) {
            e.preventDefault();
            $('#page_top').val(1);
            $('#page_bottom').val(1);
            $this.updateAllShiftsTable();
            $this.updateMyOrdersTable();
        });
        $('body').on('focusout', '#time_start', function (e) {
            e.preventDefault();
            $('#page_top').val(1);
            $('#page_bottom').val(1);
            $this.updateAllShiftsTable();
        });
        $('body').on('focusout', '#time_end', function (e) {
            e.preventDefault();
            $('#page_top').val(1);
            $('#page_bottom').val(1);
            $this.updateAllShiftsTable();
        });
        $('body').on('keyup', 'input[name="search"]', function (e) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function () {
                e.preventDefault();
                $('#page_top').val(1);
                $('#page_bottom').val(1);
                $this.updateMyOrdersTable();
            }, 1000);
        });
        $('body').on('keyup', 'input[name="search_order_id"]', function (e) {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function () {
                e.preventDefault();
                $('#page_top').val(1);
                $('#page_bottom').val(1);
                $this.updateMyOrdersTable();
            }, 1000);
        });
        $('body').on('focusout', 'input[name="table_date"]', function (e) {
            e.preventDefault();
            $('#page_top').val(1);
            $('#page_bottom').val(1);
            $this.updateMyOrdersTable();
        });
    },
    initDateTimePickers() {
        $('body .app-pos #date').datetimepicker({
            format: 'YYYY-MM-DD',
        });
        $('body .app-pos #time_start').datetimepicker({
            format: 'YYYY-MM-DD',
        });
        $('body .app-pos #time_end').datetimepicker({
            useCurrent: false,
            format: 'YYYY-MM-DD',
        });
        $("body .app-pos #time_start").on("dp.change", function (e) {
            $('.app-pos #time_end').data("DateTimePicker").minDate(e.date);
        });
        $("body .app-pos #time_end").on("dp.change", function (e) {
            $('.app-pos #time_start').data("DateTimePicker").maxDate(e.date);
        });
    },
    updateAllShiftsTable() {
        let $this = this;
        if ($('.all-shifts').length) {
            let page = $('#page_top').val();
            let count = $('#count').val();
            let time_start = $('#time_start').val();
            let time_end = $('#time_end').val();
            $.ajax({
                type: 'GET',
                url: '/all_shifts',
                data: ({
                    page: page,
                    count: count,
                    time_start: time_start,
                    time_end: time_end,
                }),
                success: function (response) {
                    $('.all-shifts').html(response);
                    $this.initDateTimePickers();
                }
            });
        }
    },

    updateMyOrdersTable() {
        let $this = this;
        if ($('#my-orders').length) {
            let page = $('#page_top').val();
            let count = $('#count').val();
            let search = $('#search').val();
            let date = $('#date').val();
            let order_id = $('#search_order_id').val();
            $.ajax({
                type: 'POST',
                url: '/update_table_my_orders',
                data: ({
                    page: page,
                    count: count,
                    search: search,
                    date: date,
                    order_id: order_id,
                }),
                success: function (response) {
                    $('#my-orders').html(response);
                    $this.initDateTimePickers();
                }
            });
        }
    }
}
